// src/apolloClient.ts
import { ApolloClient, InMemoryCache } from '@apollo/client';

const apolloClient = new ApolloClient({
  uri: 'https://gateway.thegraph.com/api/53755fb3272bed939bcf25ec5ad1c68b/subgraphs/id/4qXpjk7wsTYPfxwKwU4eB6NcDB8QP3PQ1DUb87GefQzv',
  cache: new InMemoryCache(),
});

export default apolloClient;
